<template>
<v-form v-model="valid">
    <v-container>
        <v-row>
            <v-col cols="12" md="12">
                <h1>Users</h1>

                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :items="users" :headers="headers" :search="search" @click:row="handleClick"></v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-snackbar v-model="showSnackbar" :multi-line="false" :timeout="5000" dark color="#EE765E" class="title">
            {{ snackbarText }}
            <v-btn color="white" text @click="showSnackbar = false">Luk</v-btn>
        </v-snackbar>
    </v-container>
</v-form>
</template>

<script>
// import {    EventBus} from './../../event-bus.js';

import core from './../../mixins/core';

export default {

    data: function () {
        return {
            headers: [{
                    text: 'Email',
                    align: 'start',
                    value: 'email',
                },
                {
                    text: 'Firstname',
                    value: 'firstName'
                },
                {
                    text: 'LastName',
                    value: 'lastName'
                },
                {
                    text: 'Family',
                    filterable: false,
                    value: 'familyMember'
                },
                {
                    text: 'Role',
                    value: 'roles'
                }
            ],
            search: "",
            editMode: true,
            users: [],
            showSnackbar: false,
            snackbarText: "",
            valid: false,

        }
    },
    mixins: [core],
    mounted() {
        this.fetchUsers().then((users) => {
            this.users = users;

        })
    },
    methods: {
        handleClick(user) {
            this.$router.push('/user/' + user.rowKey);
        },
    },
    name: "Users",
};
</script>
